import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Modal} from "../../../../../components/modal/modal.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import Button from "../../../../../components/button/button.jsx";
import materialXStorageService from "../../../../../services/web/material-x-storage-service.js";
import projectUtils from "../../../../../utils/project-utils.js";
import {toast} from "react-toastify";

const ChangeQuantity = ({defaultColDef, materials, setIsLoading, refetch}) => {
    const [openModal, setOpenModal] = useState(false)
    const gridRefChangeQuantity = useRef(null);

    useEffect(() => {
        refetch()
    }, [openModal]);

    const columnDefsChangeQuantity = useMemo(() => [
        {field: "id", hide: true},
        {field: "is_unique", hide: true, filter: "agTextColumnFilter", filterParams: aggridUtils.filterParams},
        {field: "material", headerName: "Material", flex: 1, filter: "agTextColumnFilter", filterParams: aggridUtils.filterParams},
        {field: "quantity", headerName: "Quantidade", width: 100, wrapText: true, autoHeight: true,
            cellEditor: 'agTextCellEditor', editable: true,
            valueSetter: ({data, newValue, oldValue}) => {
                if (newValue < data.caution) {
                    toast.warning("Quantidade menor que em cautela.")
                    return true;
                }
                data.new_quantity = newValue
                return false;
            },
            valueFormatter: params => params.data.new_quantity || params.value,
            valueGetter: (params) => {
                return params.data.new_quantity || params.data.quantity
            },
            cellRenderer: ({data, value}) => {
                if (data.new_quantity) {
                    return <span className={"text-red-500"}>{value}</span>
                }

                return value
            }
        },
    ], []);

    const updateQuantity = () => {
        gridRefChangeQuantity.current?.api?.stopEditing();
        setIsLoading(true)
        const updated = gridRefChangeQuantity.current.props.rowData.filter((i) => i.new_quantity && i.new_quantity > 0);

        const formData = new FormData()
        const data = updated.map(({id, new_quantity}) => ({id, new_quantity}))
        formData.append("data", data.length > 0 ? JSON.stringify(data) : "")

        materialXStorageService.updateQuantity(formData)
            .then(() => {
                setOpenModal(false)
            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <>
            <Button className={"mb-2"} onClick={() => setOpenModal(true)}>
                Ajuste
            </Button>

            <Modal alignTop={true} open={openModal} setOpen={setOpenModal} title={"Ajuste de materiais"} className={"w-6/12"}>
                <Modal.Body>
                    <div className={"min-h-[74px]"}>
                        <p className={"font-bold text-[14px] mb-2"}>Altere a quantidade dos materiais na tabela</p>
                        <AgGridReact
                            ref={gridRefChangeQuantity}
                            rowData={materials.filter(m => !m.is_unique)}
                            columnDefs={columnDefsChangeQuantity}
                            defaultColDef={defaultColDef}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme({noHover: true})}
                            domLayout='autoHeight'
                            onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button target="primary" onClick={updateQuantity} actionFeedbackType='save'>

                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChangeQuantity;